export const FORM = `{
  id
  data
  partner_id
  status
  form_source
  ref_link
  lastUpdatedBy
  createdAt
  updatedAt
}`

export const getForm = /* GraphQL */ `
  query GetForm($id: ID!) {
    getForm(id: $id) ${FORM}
  }
`

export const partnerControl = /* GraphQL */ `
  query PartnerControl(
    $action: String!
    $partner_id: ID
    $formID: ID
    $email: String
    $language: String
  ) {
    partnerControl(
      action: $action
      partner_id: $partner_id
      formID: $formID
      email: $email
      language: $language
    )
  }
`

// Experimente: Flags aus dem System-Item FEATURE_FLAGS (public IAM get)
export const getSystem = /* GraphQL */ `
  query GetSystem($id: ID!) {
    getSystem(id: $id) {
      id
      data
    }
  }
`
